/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, PropsWithChildren } from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { WindowLocation, useLocation } from '@reach/router';

import Container from '../Container';
import RichText from '../RichText';
import * as Text from '../Text';
import * as Link from '../Link';
import BasicAccordion from '../BasicAccordion';

import { Legal, StyledBody3 } from './styles';

const bodyOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => <Text.Legal>{children}</Text.Legal>,
    [INLINES.HYPERLINK]: (node: any, children: any) => (
      <Link.Black href={node.data.uri} fontWeight="300">
        {children}
      </Link.Black>
    ),
  },
};

const headingOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => <StyledBody3>{children}</StyledBody3>,
  },
};

const doesHashMatchSectionId = (location: WindowLocation, sectionId: string): boolean => {
  const hash = location.hash?.slice(1);
  return hash === sectionId;
};

interface LegalDisclaimerProps {
  data: {
    sectionId: string;
    bodyRTF: any;
    headingRTF: any;
  };
}

const LegalDisclaimer = ({ data, children }: PropsWithChildren<LegalDisclaimerProps>) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const { sectionId, bodyRTF, headingRTF } = data;

  useEffect(() => {
    if (doesHashMatchSectionId(location, sectionId)) {
      setOpen(true);
    }
  }, [location, sectionId]);

  if (!bodyRTF || !headingRTF) return null;

  return (
    <Legal id={sectionId}>
      <Container p={['2rem 0']} m="0 auto">
        <BasicAccordion
          open={open}
          setOpen={setOpen}
          summary={<RichText document={headingRTF} options={headingOptions} />}
        >
          {children
            ? <Text.Legal>{children}</Text.Legal>
            : <RichText document={bodyRTF} options={bodyOptions} />}
        </BasicAccordion>
      </Container>
    </Legal>
  );
};

export default LegalDisclaimer;
